/**
 * ControlPill.jsx (868m4jf4v)
 *
 * Shared header-pill primitive, two real visual variants -- not just a
 * class name difference:
 *
 *   variant="interactive": something the user ACTS on (category select,
 *   credential picker, health-source select). Pass the real control
 *   (<select> or CredentialPicker) as children, with className="dd-pill-
 *   select" on it so its own chrome is stripped and the pill's outer
 *   background/border/hover-affordance shows through instead. Fixes the
 *   credential-picker text truncation as part of this component (a
 *   max-width + ellipsis on the inner control, not a one-off per-page
 *   patch): "Use integration credential" now either fits or truncates
 *   cleanly, with the full value available as a native title tooltip on
 *   the OUTER pill (hover the pill, not just the text).
 *
 *   variant="passive": a read-only fact (FW, uptime, CPU, MAC). Renders
 *   icon + optional label + value directly, sits on the recessed
 *   --bg-page tone (matching DeviceListRow's "this is data" treatment)
 *   with no hover affordance and a default cursor. A long value (e.g. a
 *   firmware build string) truncates with ellipsis and a title tooltip on
 *   the pill itself, rather than being sized to the longest possible
 *   string -- see this ticket's own design-review note on why a tooltip
 *   was chosen over a wider box.
 *
 * Replaces: the three raw <select>/CredentialPicker header controls and
 * the FW/uptime spans in MdSwitchDetail.jsx, and MdRouterDetail.jsx's
 * local StatPill function entirely.
 */

export default function ControlPill({ variant = 'interactive', icon: Icon, label, value, tooltip, children }) {
  if (variant === 'interactive') {
    return <span className="dd-pill dd-pill-interactive">{children}</span>;
  }

  return (
    <span className="dd-pill dd-pill-passive" title={tooltip || (typeof value === 'string' ? value : undefined)}>
      {Icon && <Icon size={13} />}
      {label && <span className="dd-pill-passive-label">{label}:</span>}
      <span className="dd-pill-passive-value">{value}</span>
    </span>
  );
}
